export default "__VITE_ASSET__Dow2QNDc__"